export default __webpack_public_path__ + "static/media/hny.30f48acd.png";